<template>
  <AppPageCard>
    <template #card-title> {{ `Staff Leave Assignment` }} </template>

    <div>
      <span
        class="
          text-muted
          font-weight-bold font-size-base
          d-none d-md-inline
          mr-1
        "
      >
        {{ $t("EMPLOYEE.EMP") }}
      </span>
      <span
        class="
          text-dark-50
          font-weight-bolder font-size-base
          d-none d-md-inline
          mr-3
        "
      >
        {{ getTitle() }}
      </span>
      <IndividualEmployeeLeaveEntitlementTable
        :is-busy="isBusy"
        :items="items"
        :pagination="pagination"
        @onClickEntitlement="showModal"
      ></IndividualEmployeeLeaveEntitlementTable>

      <StaffIndividualLeaveAssignmentModal
        :assigned-leave="form"
        :is-busy="isBusy"
        @formSubmitted="fetch"
      >
      </StaffIndividualLeaveAssignmentModal>
    </div>
  </AppPageCard>
</template>

<script>
import { mapGetters } from "vuex";
import AppPageCard from "@/modules/core/components/shared/card/AppPageCard";
import IndividualEmployeeLeaveEntitlementTable from "@/modules/school/components/management/leave/entitlement/IndividualEmployeeLeaveEntitlementTable";
import StaffIndividualLeaveAssignmentModal from "@/modules/school/components/management/leave/assignment/staff/StaffIndividualLeaveAssignmentModal";

export default {
  name: "StaffIndividualLeaveAssignmentPage",
  data() {
    return {
      isBusy: false,
    };
  },
  components: {
    StaffIndividualLeaveAssignmentModal,
    IndividualEmployeeLeaveEntitlementTable,
    AppPageCard,
  },
  mounted() {
    this.fetch();
  },
  methods: {
    getTitle() {
      return this.$route.query.name;
    },

    fetch() {
      this.isBusy = true;
      this.$store
        .dispatch("fetchStaffIndividualEntitlementList", {
          id: this.$route.query.id,
        })
        .finally(() => (this.isBusy = false));
    },

    /**
     *
     * @param data
     */
    showModal(data) {
      console.log("Data ", data);

      this.isBusy = true;
      this.$store
        .dispatch("fetchStaffIndividualEntitlementForm", {
          id: data.id,
        })
        .finally(() => (this.isBusy = false));

      this.$bvModal.show("leave-page-assignment-modal");
    },
  },
  computed: {
    ...mapGetters({
      items: "getStaffIndividualEntitlementList",
      pagination: "getStaffIndividualEntitlementListPagination",
      form: "getStaffIndividualEntitlementForm",
    }),
  },
};
</script>

<style scoped></style>
